import ApplicationMainPage from './ApplicationMainPage'

export default ApplicationMainPage